import React from 'react';
import { PhoneCall, CreditCard, Info } from 'lucide-react';
import styles from './ScheduleCampaignFlow.module.css';

export type CallType = 'payment_reminder' | 'patient_info_gathering';

interface Props {
    selected: CallType | null;
    onChange: (ct: CallType) => void;
}

const OPTIONS: { value: CallType; label: string; description: string; icon: React.FC<any> }[] = [
    {
        value: 'payment_reminder',
        label: 'Payment Reminder',
        description: 'Automated outreach for outstanding balances, bills, and co-pays.',
        icon: CreditCard,
    },
    {
        value: 'patient_info_gathering',
        label: 'Patient Info Gathering',
        description: 'Collect patient information, verify insurance, or follow up on visits.',
        icon: Info,
    },
];

const Step1CallType: React.FC<Props> = ({ selected, onChange }) => (
    <div className={styles.stepContent}>
        <div className={styles.stepHeading}>
            <PhoneCall size={22} className={styles.stepHeadingIcon} />
            <div>
                <h3 className={styles.stepTitle}>Select Call Type</h3>
                <p className={styles.stepSubtitle}>Choose the purpose for this campaign. You can only run one type per campaign.</p>
            </div>
        </div>

        <div className={styles.callTypeGrid}>
            {OPTIONS.map(opt => {
                const Icon = opt.icon;
                const isActive = selected === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        className={`${styles.callTypeCard} ${isActive ? styles.callTypeCardActive : ''}`}
                        onClick={() => onChange(opt.value)}
                    >
                        <div className={`${styles.callTypeCardIcon} ${isActive ? styles.callTypeCardIconActive : ''}`}>
                            <Icon size={24} />
                        </div>
                        <div className={styles.callTypeCardBody}>
                            <span className={styles.callTypeCardLabel}>{opt.label}</span>
                            <span className={styles.callTypeCardDesc}>{opt.description}</span>
                        </div>
                        <div className={`${styles.callTypeRadio} ${isActive ? styles.callTypeRadioActive : ''}`}>
                            {isActive && <div className={styles.callTypeRadioDot} />}
                        </div>
                    </button>
                );
            })}
        </div>
    </div>
);

export default Step1CallType;